import { render, staticRenderFns } from "./InputStars.vue?vue&type=template&id=0611a7c7&"
import script from "./InputStars.vue?vue&type=script&lang=js&"
export * from "./InputStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports